// Shared teacher-dashboard copy. Reused by the v2 StatTiles and the legacy overview so the wording
// stays in sync across both surfaces.
export const POINTS_EARNED_TOOLTIP =
  'Students earn points by answering questions correctly. Questions are assigned points based on their difficulty.';
